import { IController } from 'angular';
import { SpinnerModal } from '../../../../shared/modals/status-spinner/status-spinner.service';
import { WizardUtils } from './../../../../shared/services/wizard-utils/wizard-utils.service';

export class CreditGapsWizardCtrl implements IController {
  static $inject: string[] = ['$scope', 'SpinnerModal', 'WizardUtils'];

  currentCohortFilter;
  // bindings
  currentSchool: any;
  currentUser;

  public uiReady = false;

  constructor(public $scope, private SpinnerModal: SpinnerModal, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi() {
    this.uiReady = true;
    this.SpinnerModal.deactivateSpinner();
    this.currentCohortFilter = this.WizardUtils.getCurrentCohortFilter();
  }
}
